import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { Game } from './../../model/Game';
import { GameService } from './../../services/game.service';

@Component({
  selector: 'app-my-doors',
  templateUrl: './my-doors.component.html',
  styleUrls: ['./my-doors.component.less'],
  animations: [
    trigger(
      'menuAnimation',
      [

        transition(
          ':enter',
          [
            query(".button.new-door, .message-panel-content", [style({ opacity: 0 })]),
            style({ bottom: "100vh", top: "-100vh", opacity: 0 }),
            animate('0.4s ease-in-out',
              style({ bottom: "2vh", top: "10vh", opacity: 1 })),
            animate('0.3s ease-in-out',
              style({ bottom: "8vh", top: "3vh", opacity: 1 })),
            group([
              query(".button.new-door, .message-panel-content",
                [
                  animate('0.2s ease-in',
                    style({ opacity: 1 }))
                ]),

            ]),

          ]
        ),
        transition(
          ':leave',
          [
            animate('0.2s 0.3s ease-in-out',
              style({ bottom: "2vh", top: "10vh", opacity: 1 })),
            animate('0.6s ease-in-out',
              style({ bottom: "100vh", top: "-100vh", opacity: 0 }))
          ]
        )
      ]
    ),
  ]


})
export class MyDoorsComponent implements OnInit {

  public doors: Game[] = [];
  constructor(private router: Router, private gameService: GameService) {
    this.gameService.getMyDoors().then(r => {
      this.doors = r;
    })
  }
  public menuIn: boolean = true;
  public menuLeaveObs: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  public menuLeaves() {
    this.menuLeaveObs.next(true);
  }
  ngOnInit(): void {
  }
  public editDoor(door: Game) {
    this.router.navigate(["door/edit"], { queryParams: { "id": door.id } });

  }
  public goToNewDoor() {
    this.menuIn = false;
    this.menuLeaveObs.pipe(skip(1)).subscribe(r => {
      this.router.navigate(["door/edit"]);
    });
  }

}
